import { useTranslation } from "react-i18next";
import { FormHelperText, Grid, makeStyles, Paper } from "@material-ui/core";
import AdvancedOptions from "./AdvancedOptions";
import ActionButton from "../Actions/ActionButton";
import { ConfirmButton, ContentWrapper, SectionTitle } from "../Actions/Styled";
import { useRuleContext } from "../../context/ruleContext";

import { SmimeAction } from "@dashboard-v3/api";
import { getSmimeActionState } from "pages/Rules/Form/context/ruleSelectors";

const actions: SmimeAction[] = ["VALIDATE", "SIGN", "ENCRYPT", "DECRYPT"];

export default function SmimeActions() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const { smimeActions, failedAction } = getSmimeActionState(state.rule);
  const showRequiredError = smimeActions.length < 1;
  const classes = useStyles();

  const onActionChange = (action: SmimeAction) => () => {
    const update = {
      smimeActions: smimeActions.includes(action)
        ? smimeActions.filter(a => a !== action)
        : [...smimeActions, action],
      failedAction,
    };

    if (smimeActions.includes("VALIDATE") && action === "VALIDATE") {
      update.failedAction = {
        addSubjectInvalidSmime: false,
        subjectInvalidSmime: "",
      };
    }

    dispatch({
      type: "updateStep",
      payload: {
        step: "smimeAction",
        changes: { ...update },
      },
    });
  };

  const handleConfirm = () => {
    dispatch({ type: "confirmStep", payload: "smimeAction" });
  };

  const isConfirmDisabled = () => {
    const { smimeAction } = state.steps;
    return !smimeAction.valid || smimeAction.done;
  };

  return (
    <>
      <Paper>
        <SectionTitle type={state.type} />
        <ContentWrapper>
          <Grid container spacing={1}>
            {actions.map(action => (
              <Grid item xs={3}>
                <ActionButton
                  key={action}
                  wording={t(`smimeAction.${action}.label`)}
                  onClick={onActionChange(action)}
                  selected={smimeActions.includes(action)}
                  testid={`rules-${action}-btn`}
                  disabled={false}
                />
              </Grid>
            ))}
          </Grid>
          <div className={classes.requiredErrorContainer}>
            {showRequiredError && (
              <FormHelperText margin="dense" error>
                {t("selectOneOption")}
              </FormHelperText>
            )}
          </div>
          <ConfirmButton
            fullWidth
            size="large"
            wording={t("confirm")}
            onClick={handleConfirm}
            disabled={isConfirmDisabled()}
          />
        </ContentWrapper>
        {smimeActions.includes("VALIDATE") && <AdvancedOptions />}
      </Paper>
      <div className={classes.verticalLine} style={{ height: "30px" }} />
    </>
  );
}

const useStyles = makeStyles({
  requiredErrorContainer: { height: 21, marginTop: 15 },
  verticalLine: {
    height: "100px",
    width: "50%",
    margin: "5px 0",
    borderRight: "2px dashed #8f8f8f",
  },
});
